import Logger from "../logger/Logger.js"; 
import LoggerDateTimeDecorator from "../logger/decorator/LoggerDateTimeDecorator.js"; 
import Getter from "../getter/Getter.js";
import Storage from "../storage/Storage.js";
import ObjectStorageStrategy from "./ObjectStorageStrategy.js";
import ObjectContainerService from "./ObjectContainerService.js";
import ObjectContainer from "./ObjectContainer.js";

const buildEmptyObjectContainer = () => {    
    const logger = new LoggerDateTimeDecorator(
        new Logger()
    );
    const getter = new Getter();
    const storage = new Storage();
    const objectStorageStrategy = new ObjectStorageStrategy(
        storage, 
        getter
    );
    const objectContainerService = new ObjectContainerService(
        objectStorageStrategy, 
        getter, 
        logger
    );
    const objectContainer = new ObjectContainer(
        objectContainerService
    );

    return objectContainer;
}

export default buildEmptyObjectContainer;
